export default {
  bare: () => import("/home/runner/work/moveable-frontend/moveable-frontend/layouts/bare.vue"),
  countryselect: () => import("/home/runner/work/moveable-frontend/moveable-frontend/layouts/countryselect.vue"),
  default: () => import("/home/runner/work/moveable-frontend/moveable-frontend/layouts/default.vue"),
  embed: () => import("/home/runner/work/moveable-frontend/moveable-frontend/layouts/embed.vue"),
  entries: () => import("/home/runner/work/moveable-frontend/moveable-frontend/layouts/entries.vue"),
  home: () => import("/home/runner/work/moveable-frontend/moveable-frontend/layouts/home.vue"),
  maplayout: () => import("/home/runner/work/moveable-frontend/moveable-frontend/layouts/maplayout.vue"),
  partner: () => import("/home/runner/work/moveable-frontend/moveable-frontend/layouts/partner.vue"),
  spotdetail: () => import("/home/runner/work/moveable-frontend/moveable-frontend/layouts/spotdetail.vue")
}